import React, { useEffect, useState } from 'react';
// import { BreadCrumb } from '../../Common';
import { BreadCrumb, Loader } from '../../../../Common';
import { useHistory, useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';
import Table from './Components/Table/Table';
import { useDispatch, useSelector } from 'react-redux';
import { Constant } from '../../../../Helpers/constant';
import { GET_FEEDBACK_LIST, GET_FEEDBACK_LIST_EMPTY } from '../../../../../store/actions';
import BreadcrumbTrail from '../../../../Common/BreadcrumbTrail';
import queryString from 'query-string';
import Filter from './Components/Filters/Filter';
import CustomCard from '../Dashboard/Components/Card';
import feedbackRating from '../../../../../assets/images/feedback-rating.png';
import feedbackSubmitted from '../../../../../assets/images/feedback-submmit.png';

const Feedback = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  // Parse URL query parameters
  const { page = 1, perPageLimit = Constant.TABLE_PAGE_SIZE } = queryString.parse(location.search);

  const [loading, setLoading] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState(Number(page) - 1); // `page` is 1-based
  const [rowsPerPage, setRowsPerPage] = useState(Number(perPageLimit));
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState(null);
  const [cardData, setCardData] = useState([]);

  /* ---------------------------- REDUX STATES ---------------------------- */
  // Get Feedback
  const { getFeedback, getfeedbackLoading } = useSelector((state: any) => ({
    getFeedback: state?.GetFeedbackList?.data,
    getfeedbackLoading: state?.GetFeedbackList?.loading,
  }));

  useEffect(() => {
    // Sync state with URL
    const { page, perPageLimit } = queryString.parse(location.search);
    setCurrentPageNumber(Number(page || 1) - 1); // Default to 1-based page
    setRowsPerPage(Number(perPageLimit || Constant.TABLE_PAGE_SIZE));
  }, [location.search]);

  useEffect(() => {
    if (getFeedback !== null) {
      setCardData([
        { name: 'Feedback Rating', count: getFeedback?.data?.average_rating || 0, icon: feedbackRating },
        { name: 'Feedback Submitted', count: getFeedback?.data?.pagination?.total || 0, icon: feedbackSubmitted },
      ]);
    }
  }, [getFeedback]);

  useEffect(() => {
    if (getfeedbackLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [getfeedbackLoading]);

  useEffect(() => {
    dispatch({
      type: GET_FEEDBACK_LIST,
      payload: {
        urlParams: {
          offset: currentPageNumber * rowsPerPage,
          limit: rowsPerPage,
          ...currentlyAppliedFilters,
        },
      },
    });
  }, [currentPageNumber, currentlyAppliedFilters, rowsPerPage, dispatch]);

  console.log('check here', getFeedback?.data?.feedbacks);

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);
    console.log('currentParams', currentParams);
    const updatedParams = {
      page: currentPageNumber + 1, // Default to current page
      perPageLimit: rowsPerPage, // Default to current rowsPerPage
      ...currentParams, // Merge existing query parameters
      ...newParams, // Override with new parameters
    };

    const newUrl = queryString.stringify(updatedParams);

    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  /* ---------------------------- PAGINATION HANDLER ---------------------------- */
  const paginationHandler = pageNumber => {
    updateURLParams({ page: pageNumber + 1 });
  };

  const handleRowsPerPageChange = newRowsPerPage => {
    updateURLParams({ page: 1, perPageLimit: newRowsPerPage });
  };

  /* ---------------------------- BREADCRUM HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push('/dashboard');
    }
  };

  return (
    <>
      {loading && <Loader />}
      <div className="page-content">
        <Container fluid className="position-relative">
          {/*  ----------------------------  UI'S ---------------------------- */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0' }}>
            <BreadcrumbTrail title="Feedback Rating" navigationby={breadcrumNavigationHandler} navigation={[`Dashboard`, `Feedback Rating`]} />
            {/* <Filter filterHandler={filterSubmitHandler} /> */}
          </div>

          <div className="scrollable-1 mt-3 mb-3">
            <div className="d-inline-flex gap-4">
              {cardData?.map((item, key) => (
                <div className="card dashboard-globe-toyota-card" key={key}>
                  <CustomCard cardData={item} />
                </div>
              ))}
            </div>
          </div>

          <Table
            data={getFeedback?.data?.feedbacks}
            totalCount={getFeedback?.data?.pagination?.total}
            pageNumber={currentPageNumber}
            limit={perPageLimit}
            handleRowsPerPageChange={handleRowsPerPageChange}
            handlePageChange={paginationHandler}
          />
        </Container>
      </div>
    </>
  );
};

export default Feedback;
